import { Chart } from "chart.js/auto";

function chart(props) {
  const { refName, dataSet, data, labels, options, type } = props;
  const ctx = document.getElementById(refName);
  let data_ = data || {
    labels: labels,
    datasets: dataSet,
  };

  return new Chart(ctx, {
    type: type,
    options: options,
    data: data_,
  });
}

export default chart;
